import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {delay, distinctUntilChanged, takeUntil} from "rxjs/operators";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {select, Store} from "@ngrx/store";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {NgForm} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {OckPolicyService} from "../../../shared/services/ock-policy.service";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {ockPolicy} from "../../../shared/interface/ockPolicy";

@Component({
  selector: 'app-ock-policy-list',
  templateUrl: './ock-policy-list.component.html',
  styleUrls: ['./ock-policy-list.component.scss']
})
export class OckPolicyListComponent implements OnInit,  AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  displayedColumns: string[] = ['number', 'conclusion', 'data', 'status', 'car', 'sum', 'user', 'company', 'nip'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  dataSource: ockPolicy[] = [];

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private ockPolicyService: OckPolicyService,
    private auth: AuthService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private store: Store<StoreRootState>,
    private filterService: FilterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.ockPolicyService.getListSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: CountedAndPaginated<ockPolicy>) => {
        this.dataSource = result.items;
        this.totalData = result.pagination.total;
      });
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }
  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      shortName: 'string',
      nip: 'string',
      user: 'string',
      startConclusionAt: 'date',
      endConclusionAt: 'date',
      type: 'string',
    }, filters);
  }
  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  loadListData(): void {
    this.ockPolicyService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  public dataToString(data: string): string {
    return  data.substring(0, 10);
  }

  public statusString(status: string): string {

    switch (status) {
      case "INACTIVE":
       return  'Nieaktywna';
      case "NEW":
        return  'Nowa';
      case "ACTIVE":
        return  'Aktywna';
      case "EXCLUDED":
        return  'Oczekująca';
      case "CANCELED":
        return  'Anulowana';
      default:
        return  '';
    }
  }

  downloadReport(): void {
    this.ockPolicyService.downloadReport(this.initialFilters)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

}
